import { useRef, useState } from "react";
import axios from "axios";
import {
  Box,
  Paper,
  Typography,
  Divider,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import { useParams, useNavigate } from "react-router-dom";

export default function ActivationPayment() {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [paymentMode, setPaymentMode] = useState("UPI");
  const [referenceNo, setReferenceNo] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmitPayment = async () => {
    try {
      if (!referenceNo.trim()) {
        alert("Please enter Reference / UTR Number");
        return;
      }

      if (!selectedFile) {
        alert("Please upload payment screenshot");
        return;
      }

      setLoading(true);

      const formData = new FormData();

      formData.append("invoice_id", invoiceId);

      formData.append("client_id", localStorage.getItem("trialClientId"));

      formData.append("payment_mode", paymentMode);

      formData.append("reference_no", referenceNo);

      formData.append("screenshot", selectedFile);

      const response = await axios.post(
        // "http://localhost:5000/api/admin/subscription-payments",
        "/api/admin/subscription-payments",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      alert(response.data.message);

      navigate("/login");
    } catch (error) {
      console.error(error);

      alert(error?.response?.data?.message || "Failed to submit payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        height: "calc(100vh - 20px)",
        overflowY: "auto",
        bgcolor: "#F4F7FE",
        p: 1,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          maxWidth: 650,
          mx: "auto",
          p: 1,
          borderRadius: 3,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            color: "#2563EB",
            mb: 2,
          }}
        >
          Activation Payment
        </Typography>

        <Divider sx={{ mb: 4 }} />

        {/* Invoice Section */}

        <Box
          sx={{
            bgcolor: "#EFF6FF",
            border: "1px solid #BFDBFE",
            borderRadius: 2,
            p: 1,
            mb: 1,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Invoice ID : {invoiceId}
          </Typography>

          <Typography
            sx={{
              mt: 1,
              fontSize: 20,
              fontWeight: "bold",
              color: "#2563EB",
            }}
          >
            ₹15,000
          </Typography>

          <Typography color="text.secondary">Activation Fee</Typography>
        </Box>

        {/* UPI Section */}

        <Box
          sx={{
            bgcolor: "#F8FAFC",
            borderRadius: 2,
            p: 1,
            mb: 1,
          }}
        >
          <Typography variant="h6" fontWeight="bold" color="#2563EB">
            UPI Payment
          </Typography>

          <Typography mt={2}>UPI ID : wheelserp@okaxis</Typography>

          <Box
            sx={{
              mt: 1,
              height: 80,
              border: "1px dashed #CBD5E1",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography color="text.secondary">QR CODE HERE</Typography>
          </Box>
        </Box>

        {/* Bank Section */}

        <Box
          sx={{
            bgcolor: "#F8FAFC",
            borderRadius: 2,
            p: 1,
            mb: 1,
          }}
        >
          <Typography variant="h6" fontWeight="bold" color="#2563EB">
            Bank Transfer
          </Typography>

          <Typography mt={2}>Account Name : WheelsERP Technologies</Typography>

          <Typography>Account No : 1234567890</Typography>

          <Typography>IFSC : SBIN0001234</Typography>
        </Box>

        <Divider sx={{ mb: 4 }} />
        <input
          type="file"
          accept="image/*,.pdf"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files[0];

            if (file) {
              setSelectedFile(file);
            }
          }}
        />
        <TextField
          fullWidth
          size="small"
          label="Reference Number / UTR Number"
          value={referenceNo}
          onChange={(e) => setReferenceNo(e.target.value)}
          sx={{ mb: 2 }}
        />

        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
          <InputLabel>Payment Mode</InputLabel>

          <Select
            value={paymentMode}
            label="Payment Mode"
            onChange={(e) => setPaymentMode(e.target.value)}
          >
            <MenuItem value="UPI">UPI</MenuItem>
            <MenuItem value="BANK">Bank Transfer</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => fileInputRef.current.click()}
          sx={{
            mb: 2,
            height: 45,
          }}
        >
          {selectedFile ? selectedFile.name : "CHOOSE PAYMENT SCREENSHOT"}
        </Button>

        {selectedFile && (
          <Typography fontSize={12} color="success.main" sx={{ mb: 2 }}>
            Selected : {selectedFile.name}
          </Typography>
        )}

        <Button
          variant="contained"
          fullWidth
          disabled={loading}
          onClick={handleSubmitPayment}
          sx={{
            height: 45,
            fontSize: "15px",
            fontWeight: "bold",
            backgroundColor: "#16A34A",
            "&:hover": {
              backgroundColor: "#15803D",
            },
          }}
        >
          {loading ? "SUBMITTING..." : "SUBMIT PAYMENT"}
        </Button>
      </Paper>
    </Box>
  );
}
